import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../../helpers/export'
import SecurityService from '../../core/SecurityService'

export const postFundingLiquidity = createAsyncThunk(
  'companyAnalysis/industryAnalysis/securities/fundingLiquidity',
  async (params, { rejectWithValue }) => {
    try {
      const res = await SecurityService.postFundingLiquidity(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadFundingLiquidity = createAsyncThunk(
  'companyAnalysis/industryAnalysis/securities/fundingLiquidity/export',
  async (params) => {
    try {
      const res = await SecurityService.downloadFundingLiquidity(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
